import { ballArr, count, singleDouble, smallBig } from '../resPatterns.js';

const sscRanks = ['第一球', '第二球', '第三球', '第四球', '第五球'];
const pk10Ranks = ['冠军', '亚军', '第三名', '第四名', '第五名', '第六名', '第七名', '第八名', '第九名', '第十名'];

const getHotCold = (data, ranks) => {
  let handleData = data.reduce((a, b) => {
    let arr = ballArr(b.resultStr);
    arr.map((x, i) => {
      if (!a[i]) {
        a[i] = [];
      }
      a[i].push(x);
    });
    return a;
  }, {});

  return Object.keys(handleData).map(x => ({
    rank: ranks[x],
    ...getHotCold(handleData[x])
  }));

  function getHotCold(x) {
    let numMax = 9;
    let res = {};
    for (let i = 0; i <= numMax; i++) {
      res[i] = getContinue(i, x);
    }
    return Object.keys(res).reduce(
      (a, b) => {
        let value = res[b];
        if (value < 2) {
          a['cold'][b] = value;
        }
        if (value >= 2 && value <= 3) {
          a['warm'][b] = value;
        }
        if (value > 3) {
          a['hot'][b] = value;
        }
        return a;
      },
      {
        hot: {},
        warm: {},
        cold: {}
      }
    );
  }
  function getContinue(num, list) {
    return list.filter(x => x == num).length;
  }
};

export default (betType, data) => {
  if (betType == 'ssc') {
    return getHotCold(data, sscRanks);
  }
  if (betType == 'PK10' || betType == 'nn') {
    return getHotCold(data, pk10Ranks);
  }
};



// WEBPACK FOOTER //
// ./src/helpers/statistic/getHotCold.js